import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import * as accountCampaignPricingWhatsappActions from "../actions/account_campaign_pricing_whatsapp_actions";
import * as accountCampaignPricingWhatsappTypes from "../types/account_campaign_pricing_whatsapp_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";
import { endpoints } from "../endpoints";

function* getPricingOfAccountWhatsappCampaign(action) {
  try {
    const res = yield call(api.get, `${endpoints.SUPER_ADMIN_CAMPAIGN_PRICING_WHATSAPP}/${action.payload.id}`);
    if (res.status === 200) {
      yield put(accountCampaignPricingWhatsappActions.getPricingOfAccountWhatsappCampaignSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountCampaignPricingWhatsappActions.getPricingOfAccountWhatsappCampaignError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountCampaignPricingWhatsappActions.getPricingOfAccountWhatsappCampaignError(e));
  }
}

function* editPricingOfAccountWhatsappCampaign(action) {
  try {
    const res = yield call(api.patch, `${endpoints.SUPER_ADMIN_CAMPAIGN_PRICING_WHATSAPP}/${action.payload.id}`, action.payload.data);
    if (res.status === 200) {
      yield put(accountCampaignPricingWhatsappActions.editPricingOfAccountWhatsappCampaignSuccess(res.data));
      yield put(accountCampaignPricingWhatsappActions.getPricingOfAccountWhatsappCampaignRequest(action.payload.loadingData));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountCampaignPricingWhatsappActions.editPricingOfAccountWhatsappCampaignError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountCampaignPricingWhatsappActions.editPricingOfAccountWhatsappCampaignError(e));
  }
}

function* getPricingOfAccountWhatsapp2Campaign(action) {
  try {
    const res = yield call(api.get, `${endpoints.SUPER_ADMIN_CAMPAIGN_PRICING_WHATSAPP_2}/${action.payload.id}`);
    if (res.status === 200) {
      yield put(accountCampaignPricingWhatsappActions.getPricingOfAccountWhatsapp2CampaignSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountCampaignPricingWhatsappActions.getPricingOfAccountWhatsapp2CampaignError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountCampaignPricingWhatsappActions.getPricingOfAccountWhatsapp2CampaignError(e));
  }
}

function* editPricingOfAccountWhatsapp2Campaign(action) {
  try {
    const res = yield call(api.patch, `${endpoints.SUPER_ADMIN_UPDATE_CAMPAIGN_PRICING_WHATSAPP_2}`, action.payload.data);
    if (res.status === 200) {
      yield put(accountCampaignPricingWhatsappActions.editPricingOfAccountWhatsapp2CampaignSuccess(res.data));
      yield put(accountCampaignPricingWhatsappActions.getPricingOfAccountWhatsapp2CampaignRequest(action.payload.loadingData));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountCampaignPricingWhatsappActions.editPricingOfAccountWhatsapp2CampaignError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountCampaignPricingWhatsappActions.editPricingOfAccountWhatsapp2CampaignError(e));
  }
}
export default function* accountCampaignPricingWhatsappSaga() {
  yield takeLatest(accountCampaignPricingWhatsappTypes.getPricingOfAccountWhatsappCampaign.GET_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_REQUEST, getPricingOfAccountWhatsappCampaign);
  yield takeLatest(accountCampaignPricingWhatsappTypes.editPricingOfAccountWhatsappCampaign.EDIT_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_REQUEST, editPricingOfAccountWhatsappCampaign);
  yield takeLatest(accountCampaignPricingWhatsappTypes.getPricingOfAccountWhatsapp2Campaign.REQUEST, getPricingOfAccountWhatsapp2Campaign);
  yield takeLatest(accountCampaignPricingWhatsappTypes.editPricingOfAccountWhatsapp2Campaign.REQUEST, editPricingOfAccountWhatsapp2Campaign);
}
